export default "__VITE_ASSET__c0dc4520__"